import React from 'react';
import { Sparkles, ChevronUp } from 'lucide-react';

interface BookExpandableHeaderProps {
  bookId: string;
  onCollapse?: () => void;
}

export const BookExpandableHeader: React.FC<BookExpandableHeaderProps> = ({
  bookId,
  onCollapse,
}) => {
  return (
    <div className="flex items-center justify-between gap-2 pb-2.5 border-b border-slate-200/80">
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 rounded-lg bg-indigo-100 text-indigo-700 flex items-center justify-center shrink-0">
          <Sparkles className="w-3.5 h-3.5" />
        </div>
        <div>
          <span className="font-bold text-slate-800 text-xs tracking-tight">
            Rincian Lengkap & Status Registrasi UIBN
          </span>
          <span className="text-[10px] text-slate-500 block">
            ID Entri: {bookId.slice(0, 16)}...
          </span>
        </div>
      </div>

      {onCollapse && (
        <button
          type="button"
          onClick={onCollapse}
          className="px-2 py-1 rounded-lg bg-white hover:bg-slate-200 text-slate-600 border border-slate-200 text-[11px] font-medium flex items-center gap-1 transition cursor-pointer"
          title="Tutup Rincian"
        >
          <span>Tutup</span>
          <ChevronUp className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};
